import { render, staticRenderFns } from "./addSupplierLogisticsProviderModal.vue?vue&type=template&id=b5bd7b12"
import script from "./addSupplierLogisticsProviderModal.vue?vue&type=script&lang=js"
export * from "./addSupplierLogisticsProviderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports